import { ReactNode } from "react";
import { Skeleton as MatSkeleton } from "@material-ui/lab";

type SkeletonProps = {
  children: ReactNode;
  showSkeleton: boolean;
  width?: number;
  height?: number;
};

export function Skeleton({
  children,
  showSkeleton,
  width = 125,
  height = 30,
}: SkeletonProps) {
  if (showSkeleton) {
    return <MatSkeleton variant="rect" width={width} height={height} />;
  }

  return <>{children}</>;
}
